<p>
  <b>
    {{ 'CATALOG.DETAILS_PAGE.ERROR_NOTIFICATION.ADD_TO_CART.TITLE' | translate }}
  </b>
  {{ 'CATALOG.DETAILS_PAGE.ERROR_NOTIFICATION.ADD_TO_CART.LABEL' | translate }}
  <a (click)="reloadPage()">
    {{ 'CATALOG.DETAILS_PAGE.ERROR_NOTIFICATION.ADD_TO_CART.LINK' | translate }}
  </a>
  {{ 'CATALOG.DETAILS_PAGE.ERROR_NOTIFICATION.ADD_TO_CART.CONTENT' | translate }}
</p>
